/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 18:58:39
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/TextOnly/index.tsx
 */
import React from 'react';
import css from './css.less';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import EditDeleteIconContainer from '../EditDeleteIconContainer';

const TextOnlyContainer = (props) => {
  const { name, additional, containerClassName, onDelete } = props;
  return (
    <EditDeleteIconContainer
      frontPart={
        <React.Fragment>
          <div className={css.sku}>
            <NoWrapContainer>
              <GlobalTooltip title={name}>{name}</GlobalTooltip>
            </NoWrapContainer>
          </div>
        </React.Fragment>
      }
      onDelete={onDelete}
      containerClassName={containerClassName}
      additional={additional}
    />
    // <div className={`${css.container} ${containerClassName || ''}`}>
    //   <div className={css.contentContainer}>

    //   </div>
    //   {additional}
    //   <FormOutlined className={css.icon} onClick={onClick} />
    //   {onDelete && <DeleteIcon onDelete={onDelete} />}
    // </div>
  );
};
export default TextOnlyContainer;
